import React from 'react';

// Navigation
import NavCrumbs from 'routes/dashboard/nav-crumbs';

export default function (props) {

  let { student } = props;

  let crumbs = [
        {name: 'Students', path: 'students'},
        {name: 'All', path: 'students/all'},
        {name: '...', path: '#'},
  ];

  if (student != null) {
    crumbs[2] =  { name: `${student.firstName} ${student.lastName}`, path: `student/all/${student._id}` }
  };

  return (
   <div>
       <NavCrumbs crumbs={crumbs} />
       {props.children}
   </div>
  )
}
